/**
 * 한글 조사 구분 (-이/-가, -을/-를, -은/-는, -와/-과)
 * @param format [{이/을/은/과}, {가/를/는/와}]
 * @param word 조사 앞 음절 또는 단어
 */
type TProps = {
  format: string[];
  word: string | undefined;
};

export const postPosition = ({ format, word }: TProps) => {
  if (!word) return '';

  const charCode = word.charCodeAt(word.length - 1);
  const consonantCode = (charCode - 44032) % 28;

  return consonantCode === 0 ? format[1] : format[0];
};

export const postPositionWithWord = ({ format, word }: TProps) => {
  if (!word) return '';

  const charCode = word.charCodeAt(word.length - 1);
  const consonantCode = (charCode - 44032) % 28;

  return word + (consonantCode === 0 ? format[1] : format[0]);
};
